module.exports = __webpack_public_path__ + "img/my-photo-black-and-white.9fc46ade.jpeg";